import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
export const BrandContext = createContext(undefined);
export const BrandProvider = ({ children, config }) => {
    return (_jsx(BrandContext.Provider, { value: config, children: children }));
};
export const useBrandContext = () => {
    const context = useContext(BrandContext);
    if (context === undefined) {
        throw new Error("useBrandContext must be used within a BrandProvider");
    }
    return context;
};
